import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function getOrders(payload) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/order/search',
        headers: getApiHeader(),
        withCredentials: true,
        data: payload,
    }

    return axios(options)
}

export function syncValidateOrder() {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/order/validatesync',
        headers: getApiHeader(),
        withCredentials: true
    }
    return axios(options)
}

export function syncOrders() {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/order/sync',
        headers: getApiHeader(),
        withCredentials: true
    }

    return axios(options)
}

export function syncOrdersBackground() {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/order/syncbackground',
        headers: getApiHeader(),
        withCredentials: true
    }
    return axios(options)
}

export function addOrder(payload) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/order/create',
        headers: getApiHeader(),
        withCredentials: true,
        data: payload,
    })
}

export function createShipment(payload) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/order/addshipmentandpackage',
        headers: getApiHeader(),
        withCredentials: true,
        data: { OrderIds: payload },
    })
}

export function deleteOrders(payload) {
    return axios({
        method: 'DELETE',
        url: process.env.REACT_APP_URL + '/api/order/delete',
        headers: getApiHeader(),
        withCredentials: true,
        data: { OrdersID: payload },
    })
}

export function checkPostalCode(payload) {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/common/checkzipcode?postalCode=' + payload,
        withCredentials: true,
        headers: getApiHeader(),
    })
}

export function editOrder(order_id) {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/order/' + order_id,
        withCredentials: true,
        headers: getApiHeader(),
    })
}

export function updateOrder(payload) {
    return axios({
        method: 'PUT',
        url: process.env.REACT_APP_URL + '/api/order/update?orderID=' + payload.order_id,
        withCredentials: true,
        headers: getApiHeader(),
        data: payload
    })
}

export function restoreOrderAmazon(payload) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/originalorder/getoriginal',
        headers: getApiHeader(),
        withCredentials: true,
        data: {
            ChannelOrderID: payload.channel_order,
            ChannelID: payload.channel_id
        }
    })
}

export function convertName(payload) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/common/convertjapanese',
        headers: getApiHeader(),
        withCredentials: true,
        data: payload
    })
}

export function channelOrderItemOfOrderFromAmazon(payload) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/originalorder/getoriginal',
        headers: getApiHeader(),
        withCredentials: true,
        data: {
            ChannelOrderID: payload,
            ChannelID: 2,
            isOnlyChannelItems: true
        }
    })
}

/**
 * get list import history of order
 * API: /api/orderimport/history
 * response: {code, message, data: { items: [] }}
 */
export function getImportHistoryOrders(payload) {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/import/getimportedhistory',
        headers: getApiHeader(),
        withCredentials: true,
        responseType: 'json',
        params: payload
    });
}

/**
 * get list import history of order
 * API: /api/orderimport/historyDetail
 * response: {code, message, data: { ID, ImportDatatime, ... items: [{ErrorLine, ErrorColumn, ..}] }}
 */
export function getImportHistoryOrderDetail(importID) {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/import/getimportresultdetail',
        headers: getApiHeader(),
        withCredentials: true,
        params: {
            importResultId: importID
        },
        responseType: 'json',
    });
}

export function getImportDataMapping() {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/import/getimportdatamapping',
        headers: getApiHeader(),
        withCredentials: true,
    })
}

export function uploadFileOrder(payload) {
    const params = new FormData();
    params.append('mappingId', payload.mappingId);
    params.append('importFile', payload.importFile);
    params.append('timeZone', payload.timeZone);
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/import/importfromfile',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
        withCredentials: true,
        data: params
    })
}

export function importOrder(payload) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/import/saveimportingorders',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true
    })
}

export function checkItemNameMapping(payload) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/order/checkitemnamemapping',
        headers: getApiHeader(),
        data: payload,
        withCredentials: true,
    })
}

export function splitOrders(data) {
    return axios({
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/order/splitorder',
        headers: getApiHeader(),
        data,
        withCredentials: true,
    })
}

export function getFulfillmentSetting(data) {
    return axios({
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/order/fulfillmentsetting',
        headers: getApiHeader(),
        data,
        withCredentials: true,
    })
}

export function getImportedBackgroundFlag() {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/order/getimportedbackgroundflag',
        headers: getApiHeader(),
        withCredentials: true
    }
    return axios(options)
}


// WEBPACK FOOTER //
// ./src/utils/orders.js